import type {
	CreateSnippetRequest,
	SnippetsPluginOptions,
} from '@atlassian/editor-plugin-snippets';

import { ANALYTICS_ORIGIN } from '../../constants/snippetAnalytics.ts';

import {
	useHandleCreateSnippet,
	type UseHandleCreateSnippetProps,
} from './useHandleCreateSnippet.ts';

export const useCreateSnippetFromRequest = (
	createSnippetHandlerProps?: UseHandleCreateSnippetProps,
): NonNullable<SnippetsPluginOptions['onCreateSnippet']> => {
	const handleCreateSnippet = useHandleCreateSnippet({
		contentId: createSnippetHandlerProps?.contentId ?? '',
		spaceId: createSnippetHandlerProps?.spaceId ?? '',
		spaceKey: createSnippetHandlerProps?.spaceKey ?? '',
		editorAPIRef: createSnippetHandlerProps?.editorAPIRef,
	});

	return ({ adf, origin }: CreateSnippetRequest) => {
		const analyticsOrigin =
			origin === 'contextualToolbar'
				? ANALYTICS_ORIGIN.CONTEXTUAL_TOOLBAR
				: ANALYTICS_ORIGIN.BLOCK_MENU;

		handleCreateSnippet(analyticsOrigin, adf);
	};
};
